import { Injectable } from '@angular/core';
import { isNullOrEmptyString } from '../_helpers';
import { Farm, Login, SmagTokens, SmagUser } from '../_models';

@Injectable({
  providedIn: 'root'
})
export class localStorageService {

  /**
   * Clés Current_user
   */
  static _currentUserKey:string = 'current_user';
   /**
   * Clés smag_user
   */
  static _smagUserKey:string = 'smag_user';

     /**
   * Clés farms
   */
  static _farmsUserKey:string = 'farms';

  constructor() {

  }
 //#region functions
 /**
  * Nettoyage des elements enregistré en session local front
  */
 public static clear(){
   localStorage.clear();
 }
 /**
  * Attribution de l'élément à cette clés
  * @param key clés de la propriété
  * @param value json String
  * @returns void
  */
  public static set(key:string, value:string) {
    return localStorage.setItem(key, value)
  }

  /**
   * Suppression de l'élément selon la céls si présent
   * @param key 
   * @returns void
   */
  public  static remove(key:string) {
    return localStorage.removeItem(key)
  }

  /**
   * Retourne l'élément selon la clés
   * @param key 
   * @returns string|null
   */
  public static get(key:string):string|null {
    return localStorage.getItem(key);
  }

   /**
   * Enregistre l'objet en Json si non null
   * @param _iKey clés objet si null efface juste en mémoire
   * @param _iSaveObject 
   */
   private static SetJson(_iKey : string,_iSaveObject:any|null){
     this.remove(_iKey);
     if(_iSaveObject){
      this.set(_iKey, JSON.stringify(_iSaveObject));
     }
  }


  /**
   * Retourne depuis localStorage l'objet serialisé
   * @param key clés
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  private static getJson<T>(key:string,nullOnMissing:boolean):any|null{
    let JsonValue  = this.get(key);
    if(!nullOnMissing && isNullOrEmptyString(JsonValue)){
      JsonValue = "{}";
    }
    if(JsonValue && !isNullOrEmptyString(JsonValue)){
   
      return JSON.parse(JsonValue) as T
    }else{
      return null;
    }

  }
  //#endregion

  //#region Current_User
  /**
   * Retourne la class Login enregistrée en storage
   * de Current_User
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  public static GetJsonLogin(nullOnMissing:boolean=false):Login{
    return this.getJson<Login>(this._currentUserKey,nullOnMissing)
   
  }

   /**
   * Retourne la class SmagTokens enregistrée en storage
   * de Current_User
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  public static GetJsonSmagTokens(nullOnMissing:boolean=false):SmagTokens{
    return this.getJson<SmagTokens>(this._currentUserKey,nullOnMissing)
  }

  /**
   * Retourne les données brute enregistrée en storage
   * de Current_User
   * il peut etre format Login || SmagTokens
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  public static GetJsonCurrentUserBrut(nullOnMissing:boolean=false):any{
    return this.getJson<any>(this._currentUserKey,nullOnMissing);
  }

   /**
   * retourne les exploitations de l'utilisateur actuel
   * 
   * @returns 
   */
  public static GetJsonUserFarms():{ [userId: string]: Farm[]; }{
    return JSON.parse(localStorageService.get(this._farmsUserKey) ?? "[]") as { [userId: string]: Farm[]; }
  }

   /**
    * enregistre les exploitations de l'utilisateur actuel dans le localStorage.
    * @param userFarms The farms of the current user to be stored in localStorage.
    */
  public static SetUserFarms(userFarms: { [userId: string]: Farm[]; }): void {
    this.SetJson(this._farmsUserKey, userFarms);
  }


    /**
   * Enregistrement du new Login|SmagTokens
   * suppression ancien
   * @param _iNewSmagUser si null il aura juste effacé l'ancien
   */
  public static SetCurrentUser(_iNewCurrentUser:Login|any|SmagTokens|null){
    this.SetJson(this._currentUserKey,_iNewCurrentUser);
  }
 //#endregion
 //#region Smag_User
   /**
   * Retourne les données brute enregistrée en storage
   * de smag_user
   *  
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  static GetJsonSmagUserBrut(nullOnMissing:boolean=false):any{
    return this.getJson<any>(this._smagUserKey,nullOnMissing);
  }

  /**
   * Retourne la class SmagUser enregistrée en storage
   * de smag_user
   * @param nullOnMissing :true si clés ou pas de donnée  :retourne null sinon objet vide
   * @returns 
   */
  static GetJsonSmagUser(nullOnMissing:boolean=false):SmagUser{
    return this.getJson<SmagUser>(this._smagUserKey,nullOnMissing)
  }

  /**
   * Enregistrement du new SmagUser
   * suppression ancien
   * @param _iNewSmagUser si null il aura juste effacé l'ancien
   */
  static SetSmagUser(_iNewSmagUser:SmagUser|null){
      this.SetJson(this._smagUserKey,_iNewSmagUser)
  }
  //#endregion


 
}
